import React, { useEffect, useState } from 'react';
import { Alert, Button, Checkbox, Modal } from 'antd';

const IS_DEV = import.meta.env.DEV;

export default function GenerateDealSheetModal({
  open,
  orderRow,
  onCancel,
  onGenerate,
  onPreview,
  loading = false,
  previewLoading = false,
}) {
  const canEditFees = orderRow?.can_edit_deal_sheet_fees !== false;
  const saved = orderRow?.manual_deal_sheet_options || {};

  const [includeTds, setIncludeTds] = useState(saved.include_tds === true);
  const [includeStampDuty, setIncludeStampDuty] = useState(
    saved.include_stamp_duty !== false
  );
  const [forceRegenerate, setForceRegenerate] = useState(false);

  useEffect(() => {
    if (!open) return;
    setIncludeTds(saved.include_tds === true);
    setIncludeStampDuty(saved.include_stamp_duty !== false);
    setForceRegenerate(!!orderRow?.manual_deal_sheet_url);
  }, [open, orderRow, saved.include_tds, saved.include_stamp_duty]);

  const buildOptions = () => ({
    include_tds: includeTds,
    include_stamp_duty: includeStampDuty,
    force_regenerate: forceRegenerate,
  });

  const handleOk = () => {
    onGenerate(buildOptions());
  };

  const handlePreview = () => {
    if (onPreview) onPreview(buildOptions());
  };

  const isRegenerate = Boolean(orderRow?.manual_deal_sheet_url);

  return (
    <Modal
      title={isRegenerate ? 'Regenerate Deal Sheet' : 'Generate Deal Sheet'}
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        ...(IS_DEV && onPreview
          ? [
              <Button
                key="preview"
                loading={previewLoading}
                disabled={loading}
                onClick={handlePreview}
              >
                Preview (dev)
              </Button>,
            ]
          : []),
        <Button
          key="generate"
          type="primary"
          loading={loading}
          disabled={previewLoading}
          onClick={handleOk}
        >
          {isRegenerate ? 'Regenerate PDF' : 'Generate PDF'}
        </Button>,
      ]}
      destroyOnClose
    >
      <div className="space-y-4">
        <Checkbox
          checked={includeTds}
          disabled={!canEditFees}
          onChange={(e) => setIncludeTds(e.target.checked)}
        >
          Include TDS deduction
        </Checkbox>
        <div>
          <Checkbox
            checked={includeStampDuty}
            disabled={!canEditFees}
            onChange={(e) => setIncludeStampDuty(e.target.checked)}
          >
            Include stamp duty
          </Checkbox>
        </div>
        {isRegenerate ? (
          <div>
            <Checkbox
              checked={forceRegenerate}
              disabled={!canEditFees}
              onChange={(e) => setForceRegenerate(e.target.checked)}
            >
              Force regenerate (overwrite existing PDF)
            </Checkbox>
          </div>
        ) : null}
        <Alert
          type="info"
          showIcon={false}
          message={
            canEditFees
              ? 'TDS and stamp duty can be changed until shares are transferred.'
              : 'TDS, stamp duty, and regeneration are locked after shares are transferred.'
          }
          className="text-sm"
        />
      </div>
    </Modal>
  );
}
